const PbxxRecord = require('../pbxx_record')

module.exports = class EmailShare extends PbxxRecord {
  static get class_name() {
    return 'EmailShare'
  }
}
